import { defineMessage } from 'react-intl';

/** Section title for favorited stations on the logger status screen. */
export const favoritesSectionMessage = defineMessage({
  id: 'logger.statusScreen.favoritesSection',
  defaultMessage: 'Favoritas ({count})',
});

/** Section title for stations owned by the authenticated client. */
export const myStationsSectionMessage = defineMessage({
  id: 'logger.statusScreen.myStationsSection',
  defaultMessage: 'Mis Emisoras ({count})',
});

/** Section title for external stations listed individually (not via a group). */
export const sharedStationsSectionMessage = defineMessage({
  id: 'logger.statusScreen.sharedStationsSection',
  defaultMessage: 'Emisoras externas ({count})',
});

/** Section title for stations that belong to a shared group. */
export const groupSectionMessage = defineMessage({
  id: 'logger.statusScreen.groupSection',
  defaultMessage: '{name} ({count})',
});
